import { useLocation, Link } from "wouter";
import { Search, Map, Route, Settings, Shield, type LucideIcon } from "lucide-react";

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
}

export const NAV_ITEMS: NavItem[] = [
  { path: "/", label: "Search", icon: Search },
  { path: "/map", label: "Map", icon: Map },
  { path: "/route", label: "Route", icon: Route },
  { path: "/fuel-security", label: "Security", icon: Shield },
  { path: "/settings", label: "Settings", icon: Settings },
];

export function BottomNav() {
  const [location] = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass-panel border-t border-white/10 lg:hidden">
      <div className="flex items-center justify-around h-16 px-2 max-w-lg mx-auto">
        {NAV_ITEMS.map(({ path, label, icon: Icon }) => {
          const isActive = location === path;
          return (
            <Link key={path} href={path}>
              <button
                type="button"
                className={`
                  flex flex-col items-center justify-center gap-1 w-14 h-14 rounded-xl transition-all duration-200
                  ${isActive
                    ? "text-primary"
                    : "text-muted-foreground hover:text-foreground"
                  }
                `}
              >
                <Icon size={20} className={isActive ? "drop-shadow-[0_0_8px_rgba(249,115,22,0.5)]" : ""} />
                <span className={`text-[10px] font-medium tracking-wide ${isActive ? "font-bold" : ""}`}>
                  {label}
                </span>
                {isActive && (
                  <div className="absolute bottom-1 w-6 h-0.5 rounded-full bg-primary" />
                )}
              </button>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
